import { get } from "lodash";
import React from "react";
import styled from "styled-components/macro";
import { useSelector } from "react-redux";
import Constants from "../../constants";
import { ItemType } from "../../store/models/itemType";
import { getAppConfig, getMenuCache, getLanguage, getSelectedMenu } from "../../store/sagas/selectors";
import { useBreakpoint } from "../../utilities/media-js-breakpoints";

interface VisibleProps {
    mobile: Boolean;
}

const VisibleItemContainer = styled.div<VisibleProps>`
    color: ${props => props.theme.textColorSecondary};
    font-size: ${props => (props.mobile ? "10px" : "13px")};
    padding: ${props => (props.mobile ? "4px 0px 0px 25px" : "7px")};
    margin-right: 20px;
`;

export const VisibleItemsCounter = ({ numVisibleItems }: { numVisibleItems: number }) => {
    const appConfig = useSelector(getAppConfig);
    const language = useSelector(getLanguage);
    const menus = useSelector(getMenuCache);
    const selectedMenu = useSelector(getSelectedMenu);

    const breakpoints = useBreakpoint();
    const isMobile = breakpoints.xxs || breakpoints.xs || breakpoints.sm;

    const shouldHideTotalItems = menus[selectedMenu || Constants.rootMenuId]?.items.every(
        (item: any) => item.type === ItemType.Menu || item.type === ItemType.Submenu
    );

    const menu = menus[selectedMenu];
    if (menu === undefined || shouldHideTotalItems) return null;

    const displayingText = get(appConfig, `translations.${language}.displayingFilters`, "displayingFilters");
    const ofText = get(appConfig, `translations.${language}.displayingOfFilters`, "displayingOfFilters");
    return (
        <VisibleItemContainer mobile={isMobile}>
            {`${displayingText} ${numVisibleItems} ${ofText} ${menu.items.length}`}
        </VisibleItemContainer>
    );
};
